// extracted by mini-css-extract-plugin
module.exports = {"slider__wrapper":"V_dJ","slider__element":"V_dK","itemSlider":"V_dL","itemSlider__slideWrapper":"V_dM","itemSlider__pagination":"V_dN","activeSlide":"V_dP"};